import { BodyText, ConfirmationModal } from "@knowtex-ai/components";
import type { ReactElement } from "react";

export interface DeleteAudioModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DeleteAudioModal({
  open,
  onCancel,
  onConfirm,
}: DeleteAudioModalProps): ReactElement {
  return (
    <ConfirmationModal
      open={open}
      title="Delete Audio"
      continueText="Delete"
      cancelText="Cancel"
      continueVariant="primary-danger"
      onContinue={onConfirm}
      onCancel={onCancel}
    >
      <BodyText>Are you sure you want to delete this audio file?</BodyText>
    </ConfirmationModal>
  );
}
